import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetohyderabadurbania() {



    const cardData =
    {
        keyword: 'Pune to Hyderabad Urbania On Rent',
        heading: 'Urbania on rent in pune: Pune to Hyderabad Urbania On Rent',
        headingDescription: 'Urbania On Rent in Pune offers premium and reliable Pune to Hyderabad Urbania On Rent services for corporate groups, families, tourists, and event travelers planning comfortable long-distance travel. Our well-maintained Force Urbania fleet provides spacious seating, air-conditioned comfort, ample luggage space, and smooth highway performance, making it ideal for business travel, family tours, weddings, airport transfers, and outstation journeys from Pune to Hyderabad. With professional chauffeurs experienced on long routes, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress-free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for Pune to Hyderabad Urbania hire.',

        top: 'Top Places to Visit in Hyderabad with Pune on rent in pune',


"topPlaces": [
  {
    "title": "Charminar",
    "description": "Charminar is the most iconic monument of Hyderabad, built in 1591 by Sultan Muhammad Quli Qutb Shah. Standing at the heart of the old city, the structure features four grand minarets, beautiful arches, and intricate Indo-Islamic architecture. It was constructed to commemorate the end of a deadly plague and symbolizes the foundation of Hyderabad. The surrounding Laad Bazaar, famous for bangles and traditional jewelry, adds to the vibrant cultural atmosphere. Evening lighting enhances its beauty, making it a must-visit landmark."
  },
  {
    "title": "Golconda Fort",
    "description": "Golconda Fort is a magnificent hilltop fortress known for its advanced engineering, acoustics, and rich history. Once the center of the diamond trade, it is associated with legendary gems like the Koh-i-Noor. The fort features massive gateways, royal palaces, secret tunnels, and panoramic viewpoints. The sound-and-light show narrates tales of the Qutb Shahi dynasty and brings the fort’s glorious past to life. The sunset views from the top are especially breathtaking."
  },
  {
    "title": "Ramoji Film City",
    "description": "Ramoji Film City is the world’s largest film studio complex and a major tourist attraction near Hyderabad. Spread across thousands of acres, it offers film sets, theme parks, gardens, adventure activities, and live entertainment shows. Visitors get a behind-the-scenes look at movie-making while enjoying family-friendly attractions. It is a perfect blend of entertainment, creativity, and cinematic magic."
  },
  {
    "title": "Hussain Sagar Lake",
    "description": "Hussain Sagar Lake is a massive artificial lake built in 1563, connecting Hyderabad and Secunderabad. At its center stands a giant monolithic statue of Lord Buddha, visible from all sides. The lake is popular for boating, evening walks, and enjoying city skyline views. The surrounding Tank Bund area is beautifully lit at night, making it a favorite recreational spot for locals and tourists."
  },
  {
    "title": "Birla Mandir",
    "description": "Birla Mandir is a stunning white marble temple located atop Naubat Pahad, offering panoramic views of Hyderabad city. Dedicated to Lord Venkateshwara, the temple combines Dravidian, Rajasthani, and Utkal architectural styles. The serene atmosphere, intricate carvings, and peaceful surroundings make it an ideal place for meditation and spiritual reflection."
  },
  {
    "title": "Salar Jung Museum",
    "description": "Salar Jung Museum is one of the largest art museums in India, housing an extraordinary collection of artifacts from across the world. Exhibits include sculptures, paintings, clocks, textiles, weapons, and manuscripts from India, Europe, the Middle East, and Asia. The famous musical clock and Veiled Rebecca sculpture are major highlights. The museum reflects Hyderabad’s royal legacy and cultural richness."
  },
  {
    "title": "Chowmahalla Palace",
    "description": "Chowmahalla Palace was the seat of the Nizams of Hyderabad and showcases regal architecture inspired by Persian and Mughal styles. The palace complex includes grand courtyards, elegant halls, vintage cars, royal costumes, and chandeliers. It offers a glimpse into the luxurious lifestyle of the Nizams and stands as a symbol of Hyderabad’s royal heritage."
  },
  {
    "title": "Mecca Masjid",
    "description": "Mecca Masjid is one of the oldest and largest mosques in India, located near Charminar. Built using bricks brought from Mecca, it can accommodate thousands of worshippers at a time. The mosque’s massive arches, granite courtyard, and peaceful ambiance make it a significant religious and architectural landmark in Hyderabad."
  },
  {
    "title": "Qutb Shahi Tombs",
    "description": "The Qutb Shahi Tombs are a cluster of grand mausoleums built for the rulers of the Qutb Shahi dynasty. Located near Golconda Fort, these tombs feature Persian-influenced architecture, domes, and beautifully landscaped gardens. The site offers a quiet and historical atmosphere, ideal for heritage walks and photography."
  },
  {
    "title": "Lumbini Park",
    "description": "Lumbini Park is a modern urban park situated near Hussain Sagar Lake, popular for its musical fountain shows and boating facilities. The park offers leisure spaces, scenic lake views, and family-friendly attractions. In the evenings, the illuminated fountains and city lights create a lively and enjoyable environment."
  },
  {
    "title": "Laad Bazaar",
    "description": "Laad Bazaar is a bustling traditional market near Charminar, famous for its colorful bangles, pearls, bridal wear, and ethnic accessories. Walking through its narrow lanes gives visitors an authentic taste of old Hyderabad’s shopping culture. The market is especially vibrant during festivals like Ramzan and Diwali."
  }
],




"services": [
{
"name": "Pune to Hyderabad Urbania on Rent",
"description": "Pune to Hyderabad Urbania on Rent provides comfortable and reliable Urbania buses for long-distance travel between Pune and Hyderabad. The service is ideal for families, corporate groups, and tourists, offering spacious seating, clean interiors, ample luggage space, and experienced drivers for a smooth interstate journey."
},
{
"name": "Hyderabad Urbania Hire from Pune",
"description": "Hyderabad Urbania Hire from Pune offers flexible Urbania bus rental options for one-way and round-trip travel. With professional chauffeurs and well-maintained vehicles, the service ensures punctual departures, safe travel, and a relaxed journey."
},
{
"name": "Urbania Bus Rental Pune to Hyderabad",
"description": "Urbania Bus Rental Pune to Hyderabad features well-serviced buses designed for extended highway travel. The service focuses on passenger comfort, reliable performance, and safety throughout the long-distance route."
},
{
"name": "Urbania AC Bus Pune to Hyderabad",
"description": "Urbania AC Bus Pune to Hyderabad provides fully air-conditioned Urbania buses for a comfortable and climate-controlled travel experience, making long hours on the road more relaxing for all passengers."
},
{
"name": "Pune Hyderabad Urbania One Way Hire",
"description": "Pune Hyderabad Urbania One Way Hire offers convenient one-way travel solutions for travelers moving from Pune to Hyderabad, ensuring timely pickup, professional driving, and hassle-free transportation."
},
{
"name": "Pune Hyderabad Urbania Round Trip Hire",
"description": "Pune Hyderabad Urbania Round Trip Hire provides complete round-trip transport services with well-planned schedules, allowing travelers to focus on their work or leisure plans without travel concerns."
},
{
"name": "Corporate Urbania Pune to Hyderabad",
"description": "Corporate Urbania Pune to Hyderabad offers organized and professional transport solutions for corporate teams, business travel, and official tours, emphasizing punctuality, comfort, and smooth coordination."
},
{
"name": "Family Tour Urbania Pune to Hyderabad",
"description": "Family Tour Urbania Pune to Hyderabad is designed to provide a safe, spacious, and comfortable travel environment for families, ensuring an enjoyable journey for all age groups."
},
{
"name": "Luxury Urbania Pune to Hyderabad",
"description": "Luxury Urbania Pune to Hyderabad delivers a premium travel experience with modern interiors, plush seating, and superior ride comfort, ideal for travelers seeking a refined and relaxed journey."
},
{
"name": "Affordable Urbania Pune to Hyderabad",
"description": "Affordable Urbania Pune to Hyderabad provides budget-friendly Urbania bus rental services without compromising on safety or comfort, making it suitable for cost-conscious travelers and group trips."
},
{
"name": "Chauffeur Driven Urbania Pune to Hyderabad",
"description": "Chauffeur Driven Urbania Pune to Hyderabad ensures a stress-free journey with trained, verified drivers experienced in long-distance and interstate routes."
},
{
"name": "Pune Hyderabad Urbania Travel Service",
"description": "Pune Hyderabad Urbania Travel Service offers dependable and well-managed transportation solutions, focusing on comfort, reliability, and customer satisfaction throughout the journey."
},
{
"name": "Best Urbania Hire Pune to Hyderabad",
"description": "Best Urbania Hire Pune to Hyderabad is known for quality vehicles, professional service, and consistent reliability, making it a preferred choice for Pune to Hyderabad travel."
},
{
"name": "Outstation Urbania Hire Pune",
"description": "Outstation Urbania Hire Pune provides reliable Urbania bus rental services for travel from Pune to major cities and destinations, ensuring safe, comfortable, and well-coordinated outstation journeys."
},
{
"name": "Trusted Hyderabad Urbania Service",
"description": "Trusted Hyderabad Urbania Service delivers safe, dependable, and customer-focused Urbania bus rental services, ensuring a smooth and comfortable travel experience between Pune and Hyderabad."
}
],
"tableData": [
["Pune to Hyderabad Urbania on Rent", "Hyderabad Urbania Hire from Pune"],
["Urbania Bus Rental Pune to Hyderabad", "Urbania AC Bus Pune to Hyderabad"],
["Pune Hyderabad Urbania One Way Hire", "Pune Hyderabad Urbania Round Trip Hire"],
["Corporate Urbania Pune to Hyderabad", "Family Tour Urbania Pune to Hyderabad"],
["Luxury Urbania Pune to Hyderabad", "Affordable Urbania Pune to Hyderabad"],
["Chauffeur Driven Urbania Pune to Hyderabad", "Pune Hyderabad Urbania Travel Service"],
["Best Urbania Hire Pune to Hyderabad", "Outstation Urbania Hire Pune"],
["Trusted Hyderabad Urbania Service", ""]
],



whychoose : [
    {
        "WhyChooseheading": "Pune to Hyderabad Urbania On Rent for Comfortable Long-Distance Travel",
        "WhyChoosedescription": "Pune to Hyderabad Urbania On Rent is ideal for long-distance journeys, family travel, group trips, corporate tours, and leisure travel, ensuring a comfortable and hassle-free ride."
    },
    {
        "WhyChooseheading": "Spacious and Modern Urbania Buses",
        "WhyChoosedescription": "Our Urbania buses for Pune to Hyderabad travel are equipped with air-conditioning, comfortable reclining seats, ample legroom, and sufficient luggage space for a smooth long-distance journey."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Interstate Routes",
        "WhyChoosedescription": "All drivers are trained and experienced in interstate travel from Pune to Hyderabad, ensuring safe driving, punctual arrivals, and stress-free journeys."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Pune to Hyderabad Urbania On Rent offers competitive pricing with no hidden charges, making long-distance travel cost-effective and reliable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "We provide round-the-clock booking assistance and dedicated customer support for inquiries, reservations, and travel coordination."
    },
    {
        "WhyChooseheading": "Flexible Travel Packages",
        "WhyChoosedescription": "Available for one-way trips, round trips, multi-day journeys, corporate travel, and customized itineraries as per your requirements."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania buses are regularly cleaned, sanitized, and well-maintained to ensure passenger comfort and hygiene throughout the journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Our Pune to Hyderabad Urbania On Rent service ensures on-time departures, dependable travel support, and a smooth overall experience."
    }
]
}
const faqData = [
    {
        question: 'Can Pune to Hyderabad Urbania On Rent be booked for long-distance travel?',
        answer: 'Yes, it is suitable for long-distance journeys, family trips, group travel, corporate tours, and interstate travel.'
    },
    {
        question: 'How can I book Pune to Hyderabad Urbania On Rent?',
        answer: 'Bookings can be made via phone, WhatsApp, or online for quick and convenient reservations.'
    },
    {
        question: 'Why choose Pune to Hyderabad Urbania On Rent?',
        answer: 'This service offers comfortable seating, experienced drivers, clean vehicles, flexible travel plans, and transparent pricing.'
    },
    {
        question: 'Are drivers experienced for the Pune to Hyderabad route?',
        answer: 'Yes, all drivers are licensed, trained, and experienced in interstate routes including Pune to Hyderabad.'
    },
    {
        question: 'Can pickup and drop locations be customized?',
        answer: 'Absolutely. Flexible pickup and drop-off locations are available across Pune and nearby areas.'
    },
    {
        question: 'Is Pune to Hyderabad Urbania On Rent available 24/7?',
        answer: 'Yes, booking services and customer support are available 24/7.'
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all buses are thoroughly cleaned, sanitized, and well-maintained for passenger safety.'
    },
    {
        question: 'What payment options are accepted?',
        answer: 'Payments can be made via UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing.'
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey.'
    },
    {
        question: 'Is this service suitable for families and corporate groups?',
        answer: 'Yes, Pune to Hyderabad Urbania On Rent is ideal for families, corporate groups, and large travel parties.'
    }
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rahul Deshmukh',
        feedback: 'Our Pune to Hyderabad trip was very comfortable. The Urbania bus was spacious, clean, and perfect for long-distance travel.',
        rating: 5
    },
    {
        id: 2,
        name: 'Ms. Kavita Rao',
        feedback: 'Excellent service and professional driver. Pune to Hyderabad Urbania On Rent made our interstate journey smooth and stress-free.',
        rating: 5
    }
];










































































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Hyderabad Urbania On Rent",
  "image": "https://urbaniaonrentpune.in/assets/images/pune-hyderabad-urbania.jpg",
  "description": "Pune to Hyderabad Urbania On Rent offers AC Urbania buses for one-way or round-trip travel, corporate trips, family tours, pilgrimage journeys, and group travel. Chauffeur-driven Urbania buses ensure safe, comfortable, and convenient transportation from Pune to Hyderabad.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/pune-to-hyderabad-urbania-on-rent"
  }
};






    return (
        <div>

<Helmet>
  <title>
    Call:+91 9209423113 | Pune to Hyderabad Urbania On Rent | AC Urbania Bus One Way & Round Trip 
  </title>

  <meta
    name="description"
    content="Book Pune to Hyderabad Urbania On Rent for one-way or round-trip travel, corporate trips, family tours, pilgrimage journeys, and group travel. AC Urbania buses with chauffeur-driven service provide safe, comfortable, and convenient transportation from Pune to Hyderabad."
  />

  <meta
    name="keywords"
    content="Pune to Hyderabad Urbania on Rent, Hyderabad Urbania Hire from Pune, Urbania Bus Rental Pune to Hyderabad, Urbania AC Bus Pune to Hyderabad, Pune Hyderabad Urbania One Way Hire, Pune Hyderabad Urbania Round Trip Hire, Corporate Urbania Pune to Hyderabad, Family Tour Urbania Pune to Hyderabad, Luxury Urbania Pune to Hyderabad, Affordable Urbania Pune to Hyderabad, Chauffeur Driven Urbania Pune to Hyderabad, Pune Hyderabad Urbania Travel Service, Best Urbania Hire Pune to Hyderabad, Outstation Urbania Hire Pune, Trusted Hyderabad Urbania Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/88.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetohyderabadurbania;